import { render, staticRenderFns } from "./UpgradeDocument.vue?vue&type=template&id=ab2a414c&scoped=true&"
import script from "./UpgradeDocument.vue?vue&type=script&lang=js&"
export * from "./UpgradeDocument.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDocument.vue?vue&type=style&index=0&id=ab2a414c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2a414c",
  null
  
)

export default component.exports